import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
  {
    question: "What technologies do you use for web development?",
    answer: "We use modern stacks like MERN (MongoDB, Express, React, Node), MEAN, Django, Laravel, Vue.js, and more — tailored to your project's needs."
  },
  {
    question: "Do you offer UI/UX design as part of web development?",
    answer: "Yes, we offer complete UI/UX design services based on user personas and business goals, ensuring both beauty and usability."
  },
  {
    question: "Can you modernize my legacy web app?",
    answer: "Absolutely. We re-engineer and migrate legacy systems to scalable, modern web platforms with minimal downtime."
  },
  {
    question: "How secure will my web app be?",
    answer: "We implement HTTPS, OAuth, role-based access, data encryption, and other industry best security practices to keep your app safe."
  },
  {
    question: "Do you provide maintenance post-launch?",
    answer: "Yes, we offer ongoing support, performance monitoring, feature updates, and optimization services after launch."
  },
  {
    question: "Can I integrate my CRM or ERP into the app?",
    answer: "Yes, we have experience integrating various CRMs, ERPs, and third-party platforms via REST and GraphQL APIs."
  }
];

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="faq-section" id="faq">
            <div className="faq-inner">
                <div className="faq-left">
                    <img 
                        src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2070&auto=format&fit=crop" 
                        alt="Professional Tech Background" 
                        className="faq-image"
                    />
                    <div className="faq-image-overlay"></div>
                </div>

                <div className="faq-right">
                    <div className="faq-container">
                        <span className="faq-label">[ faq ]</span>
                        <h2 className="faq-title">Everything you need to know about</h2>
                        
                        <div className="faq-accordion">
                            {faqs.map((faq, index) => (
                                <div key={index} className={`faq-item ${openIndex === index ? 'active' : ''}`} onClick={() => toggle(index)}>
                                    <div className="faq-question">
                                        <span className="q-number">Q{index + 1}:</span>
                                        <span className="q-text">{faq.question}</span>
                                        <div className="q-toggle-icon"></div>
                                    </div>
                                    <div className="faq-answer">
                                        <div className="faq-answer-inner">
                                            {faq.answer}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQ;
